var geocoder;
var urlLocation;
var urlBrand;
var urlDealer;
var map;

function initMap(){
	
	var options = {
		center: {lat: 53.0622559 , lng: -1.7189575},
		zoom: 8,
	}

	map = new google.maps.Map(document.getElementById('map'), options);

	geocoder = new google.maps.Geocoder();

	drawDealerMarkers();

	checkQueryStrings();

}

function ShowDealerOnMap(dlr){
	for(i = 0 ; i< arrMarkers.length; i++){
			if(arrMarkers[i].dataName == dlr){
				//arrMarkers[i].setVisible(true);
				google.maps.event.trigger(arrMarkers[i], 'click');
			}
		}
}

function checkQueryStrings(){
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	// check if location is set
	if( urlParams.has('location') ){
		// if location is passed in url, center on that
		urlLocation = decodeURI( urlParams.get('location') );
		$('#input_findaplace').val(urlLocation);
		getUrlLocationCoords(urlLocation);

	}else if(urlParams.has('dealer')){
		urlDealer = decodeURI(urlParams.get('dealer'));
		ShowDealerOnMap(urlDealer)
		
	}else{
		//if not searching for a specific location, get users current location
		getUserLocationCoords()
	}

	if( urlParams.has('brand') ){
		urlBrand = urlParams.get('brand');
		filterByBrand(urlBrand);
	}

	
}

function filterByBrand(brand){
	$('#map_options-select-brand').val(brand).change();
}



function getUrlLocationCoords(urlLocation){

	geocoder.geocode({
                'address': urlLocation, "componentRestrictions":{"country":"UK"}
        }, function (results, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                    map.setCenter(results[0].geometry.location);
                    map.setZoom(11);
                } else {
                        //alert("Geocode was not successful for the following reason: " + status);

                }
        });

}

function getUserLocationCoords(){
	x = navigator.geolocation;
	x.getCurrentPosition(function(position){
		userLocation = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
 		map.setCenter(userLocation);
 		map.setZoom(8);
	},function(){
		console.log('failed to find user location');
		//show error msg and highlight input as red border
	});

}

var arrMarkers = Array();

function drawDealerMarkers(){

	dealerData.sort((a,b) => (a.Name > b.Name) ? 1 : ((b.Name > a.Name) ? -1 : 0))


	$.each(dealerData, function(i){
		let me = this;
		//console.log(this.Name);
		var mapCoords = new google.maps.LatLng(this.Y, this.X);
		//console.log(mapCoords);
		const newMarker = new google.maps.Marker({
			position: mapCoords,
			map: map,
			dataName: me.Name,
			dataWeb: me.Website,
			dataAddress: me.Address,
			dataPhone: me.Phone,
			dataDemo: me.OfficialDemo,
			dataSCB: me.SCB,
			dataJuliana: me.Juliana,
			dataReserve: me.Reserve,
			dataSweet: me.SweetProtection,
			
			dataCervelo: me.Cervelo,
			dataCerveloDirt: me.CerveloDirt


		});

		arrMarkers.push(newMarker);

		google.maps.event.addListener(newMarker, 'click', (function(newMarker, i) {
	        return function() {
	          
	          map.setCenter(mapCoords);
	          map.setZoom(11);
	          showDealerInfo(newMarker);

	        }
	      })(newMarker, i));

		//create html section for dealer and add to list
		var tempStr = "<b>Stockists Of: </b>";
		if(newMarker.dataSCB){tempStr+='Santa Cruz Bicycles, '};
		if(newMarker.dataJuliana){tempStr+='Juliana Bicycles, '};
		if(newMarker.dataReserve){tempStr+='Reserve, '};
		if(newMarker.dataSweet){tempStr+='Sweet Protection, '};
		//console.log(newMarker.dataCerveloDirt)
		if(newMarker.dataCerveloDirt){tempStr+='Cervelo DIRT, '}; 
		if(newMarker.dataCervelo){tempStr+='Cervelo Bicycles, '};

		var snippedStr = tempStr.slice(0, -2);

		var htmlStr = '<div class = "dealerListInfo grid__item medium-up--one-half small--one-whole" data-dlr = '+me.Name.replace(/ /g, '_')+'><h2 class = "dealerListInfo-name">'+me.Name+'</h2><div class = "feature_divider_left"></div><p id = "dealerListInfo-address">'+me.Address+'</p><p id = "dealerListInfo-phone">'+me.Phone+'</p><a id = "dealerListInfo-link" href="'+me.Website+'" target = "blank">'+me.Website+'</a><p id = "dealerListInfo-brands">'+snippedStr+'</p></div>';

		$('#list_of_dealers').append(htmlStr);
	    
	})

}

$('#map_options-select-brand').change(function(){
	//get val
	let targetBrand = $('#map_options-select-brand').val();
	showBrandMarkers(targetBrand);
	//pass to function
})

function showDealerInfo(newMarker){
	$('#dealerInfo_shop-name').html(newMarker.dataName);
	$('#dealerInfo_shop-address').html(newMarker.dataAddress);
	$('#dealerInfo_shop-phone').html(newMarker.dataPhone);
	$('#dealerInfo_shop-link').attr('href', newMarker.dataWeb);

	var tempStr = "";
	if(newMarker.dataSCB){tempStr+='Santa Cruz Bicycles, '};
	if(newMarker.dataJuliana){tempStr+='Juliana Bicycles, '};
	if(newMarker.dataReserve){tempStr+='Reserve, '};
	if(newMarker.dataSweet){tempStr+='Sweet Protection, '};
	if(newMarker.dataCervelo){tempStr+='Cervelo Bicycles, '};
	if(newMarker.dataCerveloDirt){tempStr+='Cervelo DIRT, '};
	var snippedStr = tempStr.slice(0, -2);

	$("#dealerInfo_shop-brands").html(snippedStr);

	if(newMarker.dataDemo){
	 $('#demo-center-holder').html('<img src = "https://cdn.shopify.com/s/files/1/0557/0615/7234/files/SCB-official-demo-center-blk.jpg?v=1760001015" style = "max-width: 180px">');
	  }else{
	  	 $('#demo-center-holder').html('');
	  }

	$("#dealerInfo").slideDown(400);
}

function showBrandMarkers(brand){

	//hide all markers
	for(i = 0 ; i< arrMarkers.length; i++){
		arrMarkers[i].setVisible(false);
	}

	if(brand == 'SCB') {
			for(i = 0 ; i< arrMarkers.length; i++){
				if(arrMarkers[i].dataSCB){
					arrMarkers[i].setVisible(true);
				}
			}
	}

	if(brand == 'Juliana') {
			for(i = 0 ; i< arrMarkers.length; i++){
				if(arrMarkers[i].dataJuliana){
					arrMarkers[i].setVisible(true);
				}
			}
	}

	if(brand == 'Reserve') {
			for(i = 0 ; i< arrMarkers.length; i++){
				if(arrMarkers[i].dataReserve){
					arrMarkers[i].setVisible(true);
				}
			}
	}

	if(brand == 'Sweet') {
			for(i = 0 ; i< arrMarkers.length; i++){
				if(arrMarkers[i].dataSweet){
					arrMarkers[i].setVisible(true);
				}
			}
	}

	

	if(brand == 'Cervelo') {
			for(i = 0 ; i< arrMarkers.length; i++){
				if(arrMarkers[i].dataCervelo){
					arrMarkers[i].setVisible(true);
				}
			}
	}

	if(brand == 'ALL') {
			for(i = 0 ; i< arrMarkers.length; i++){
					arrMarkers[i].setVisible(true);	
			}
	}
}

$('#btn_findaplace').click(function(){
	//validate input
	let inputVal = $('#input_findaplace').val();

	if(inputVal.length > 2){
		getUrlLocationCoords(inputVal);
		$('#input_findaplace').removeClass('input_error');
	}else{
		$('#input_findaplace').addClass('input_error');
		$('#input_findaplace').focus();
	}
})

$('#dealerInfo_close_modal').click(function(){
	$("#dealerInfo").slideUp(400);
	map.setZoom(8);
})

$(document).on('click', '.dealerListInfo', function(){
	var dlr = $(this).attr('data-dlr').replace(/_/g, ' ');

	ShowDealerOnMap(dlr);
	//animate scroll to map
	$('html, body').animate({
        scrollTop: $("#map").offset().top
    }, 1000);
})

		